// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"237":"2a880f60","802":"621f9f77"}[chunkId] + ".css";
};